export enum SearchType {
	FULL = 'full',
	NETWORK = 'network',
}
